export default "/wp-content/themes/onnit/script/cart/dist/o6SteelClub-3454aa00.jpg";